import type { TranslationInterface } from '.';

export const DutchLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Schrijf een bericht...',
  your_issue_has_been_resolved: 'Uw probleem is opgelost!',
  new_conversation: 'Nieuw gesprek',
  welcome_screen_title: 'Welkom bij onze supportchat',
  welcome_screen_description:
    'We zijn hier om te helpen! Begin een gesprek en we nemen zo snel mogelijk contact met u op.',
  your_name_placeholder: 'Uw naam',
  your_email_placeholder: 'Uw e-mailadres',
  start_chat_button: 'Praat met ondersteuning',
  start_chat_button_loading: 'Verbinding maken...',
  i_need_more_help: 'Ik heb nog meer hulp nodig',
  this_was_helpful: 'Mijn vraag is opgelost',
  optional: 'Optioneel',
  no_conversations_yet: 'Nog geen gesprekken',
  back_to_conversations: 'Terug naar gesprekken',
  closed_conversations: 'Afgesloten gesprekken',
  csat_title: 'Hoe was je gesprek?',
  csat_submitted_title: 'Je hebt het gesprek beoordeeld als',
  csat_feedback_placeholder: 'Vertel ons meer... (optioneel)',
  follow_up_placeholder: 'Verder vragen…',
  companion_layout_label: 'Indeling',
  companion_layout_floating: 'Zwevend',
  companion_layout_sidebar: 'Zijbalk',
  companion_layout_fullscreen: 'Volledig scherm',
  companion_close: 'Sluiten',
  companion_history: 'Gespreksgeschiedenis',
  companion_expand_chat: 'Chat uitvouwen',
  companion_sidebar_dock_label: 'Vastzetten',
  companion_sidebar_side_label: 'Zijde',
  companion_sidebar_left: 'Links',
  companion_sidebar_right: 'Rechts',
  companion_resize_chat: 'Chatgrootte wijzigen',
  scroll_to_bottom: 'Naar beneden scrollen',
  thinking: 'Denkt na…',
  running: 'Wordt uitgevoerd…',
  steps: 'stappen',
  step_arguments: 'Argumenten',
  step_result: 'Resultaat',
  attach_files:
    "Afbeeldingen, video's, pdf's of spreadsheets bijvoegen (maximale grootte 25 MB)",
  mark_page_active:
    'Klik op iets op de pagina om het te markeren — Esc om te annuleren',
  mark_page: 'Markeer iets op de pagina om er een vraag over te stellen',
  stop_response: 'Antwoord stoppen',
  copy_reply: 'Antwoord kopiëren',
  mentions_empty: 'Geen resultaten',
  copied: 'Gekopieerd',
  send_message: 'Bericht verzenden',
  upload_failed: 'Uploaden mislukt: {error}',
  remove_attachment: 'Bijlage verwijderen',
  json_no_items: 'Geen items',
  json_no_data: 'Geen gegevens',
  json_no_chart_data: 'Geen gegevens voor de grafiek',
  json_unsupported: 'Niet ondersteund: {type}',
  json_see_less: 'Minder weergeven',
  json_phone_agent: 'Telefoonagent',
  json_phone_agent_test: 'Testen via web',
  page_context_remove: 'Paginacontext verwijderen',
  json_see_more: 'Nog {count} weergeven',
  queued_label: '{count} In wachtrij',
  remove_queued_message: 'Bericht uit wachtrij verwijderen',
  send_queued_now: 'Berichten in wachtrij nu verzenden',
  turn_failed_message: 'Er ging iets mis en het antwoord is niet aangekomen.',
  turn_failed_retry: 'Opnieuw proberen',
  page_mark_hint: 'Klik op iets om het te markeren',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Kader',
  page_mark_shape_circle: 'Cirkel',
  page_mark_shape_arrow: 'Pijl',
  page_mark_shape_bracket: 'Haakje',
  page_mark_shape_underline: 'Onderstrepen',
  page_mark_shape_highlight: 'Markeren',
  page_mark_shape_strike_through: 'Doorhalen',
  page_mark_shape_crossed_off: 'Doorkruisen',
  page_mark_shape_aria: 'Vorm van markering: {shape}',
  page_mark_note_placeholder: 'Voeg een notitie toe… (Enter om bij te voegen)',
  page_mark_attach: 'Markering bijvoegen',
  page_mark_remove: '{label} verwijderen',
  page_mark_region: 'Gemarkeerd gebied',
  page_mark_default_message: 'Wat is dit?',
  file_rejected:
    'Het bestandstype wordt niet ondersteund of het bestand is te groot.',
  dictate: 'Dicteren',
  stop_dictation: 'Dicteren stoppen',
  dictation_mic_blocked: 'Sta microfoontoegang toe om te dicteren',
  dictation_unavailable: 'Dicteren is momenteel niet beschikbaar',
  questions_back: 'Terug',
  questions_next: 'Volgende',
  questions_send: 'Verzenden',
  questions_type_answer: 'Ik typ het zelf',
  questions_answer_placeholder: 'Typ je antwoord…',
  close_conversation_title: 'Gesprek sluiten',
  close_conversation_description:
    'Weet je zeker dat je dit gesprek wilt sluiten?',
  close_conversation_cancel: 'Nee',
  close_conversation_confirm: 'Ja',
  dialog_close: 'Sluiten',
  zoom_in: 'Inzoomen',
  zoom_out: 'Uitzoomen',
  reset_zoom: 'Zoom herstellen',
  support_chat_aria_label: 'Supportchat',
};
